function hideColorSelectorIfSiblingsPresent() {
    // Get the div with id "siblings"
    const siblingsDiv = document.getElementById('siblings');

    // Get all elements with the class "selector-wrapper--color"
    const colorSelectors = document.getElementsByClassName('selector-wrapper--fullwidth');

    // Check if the siblings div exists and if there are color selectors
    if (siblingsDiv && colorSelectors.length > 0) {
        // Hide all color selectors
        for (let i = 0; i < colorSelectors.length; i++) {
            colorSelectors[i].style.display = 'none';
        }
    } else if (!siblingsDiv) {
        console.log('The "siblings" div is not present on the page.');
    } else {
        console.log('No elements with class "selector-wrapper--color" found.');
    }
}
// Call the function when the page loads
document.addEventListener('DOMContentLoaded', hideColorSelectorIfSiblingsPresent);